import React from 'react';
import { useNavigate } from 'react-router-dom';

const QuickActions = () => {
    const navigate = useNavigate();

    const actions = [
        { label: 'New Client', path: '/admin/clients/add', icon: '👤', color: 'bg-blue-600' },
        { label: 'New Case', path: '/admin/cases/new', icon: '📁', color: 'bg-green-600' },
        { label: 'Uni App', path: '/admin/univ_apps/new', icon: '🎓', color: 'bg-indigo-600' },
        { label: 'BroadCast', path: '/admin/communications/broadcast', icon: '📢', color: 'bg-purple-600' },
    ];

    return (
        <div className="bg-gray-800 rounded-lg border border-gray-700 shadow-lg overflow-hidden flex flex-col h-full">
            <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex-shrink-0">
                <h2 className="text-blue-400 font-bold uppercase tracking-wider flex items-center gap-2 text-sm sm:text-base">
                    <span role="img" aria-label="lightning">⚡</span>
                    Quick Actions
                </h2>
            </div>
            <div className="p-4 grid grid-cols-2 gap-3">
                {actions.map((action) => (
                    <button
                        key={action.label}
                        onClick={() => navigate(action.path)}
                        className={`${action.color} hover:opacity-90 text-white p-3 rounded-lg flex flex-col items-center justify-center gap-2 transition-transform transform active:scale-95`}
                    >
                        <span className="text-xl">{action.icon}</span>
                        <span className="text-xs font-bold uppercase">{action.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default QuickActions;
